import { render, staticRenderFns } from "./AmountToBuy.vue?vue&type=template&id=739f2e24&scoped=true&"
import script from "./AmountToBuy.vue?vue&type=script&lang=ts&"
export * from "./AmountToBuy.vue?vue&type=script&lang=ts&"
import style0 from "./AmountToBuy.vue?vue&type=style&index=0&id=739f2e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f2e24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VBtn,VChip,VChipGroup})
